import * as React from "react";
import ReactDOM from "react-dom";

import { Home } from "./Home";
import "./home.scss";

ReactDOM.render(<Home />, document.getElementById("root"));
